export default __webpack_public_path__ + "9acf99a1bc539d9fd91938842a842402.png";